import React, { useRef, useState } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import axios from 'axios';
import {
    validaSoloNumero, formatMoneda, validaMonto, formatoMonto, validaNumeroTelefono, validaEmail
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import CatalogoCuentasAsientos from '../../catalogos/catalogoAsientosCuentas';

export const ModalIncluirCuenta = (props) => {

    let token = sessionStorage.getItem('jwtToken');
    let op = require('../../../public/modulos/datos');
    let anio = JSON.parse(sessionStorage.getItem('anioactu'))
    const fechasistema = moment(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD');
    const deshabilitado = false;

    const idefiscal = JSON.parse(sessionStorage.getItem('idefiscal'));

    /*  variables de referencias */
    const txtDebe = useRef();
    const txtHaber = useRef();
    const txtCuentaContable = useRef();
    const txtDescripcion = useRef();
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtCedula = useRef();
    const txtNombreRespon = useRef();
    const txtObserStatus = useRef();
    const txtStatus = useRef();
    const txtDireccionRespon = useRef();
    const txtMonto = useRef();
    const txtCedulaPro = useRef();
    const txtNombrePro = useRef();
    const txtNumPro = useRef();
    const txtDireccionPro = useRef();
    const txtId = useRef();
    const txtFechaIns = useRef();
    const txtApeRespon = useRef();
    const txtEmail1 = useRef();
    const txtEmail2 = useRef();
    const txtFechNac = useRef();
    const cmbNacionalidad = useRef();
    const txtTipoNac = useRef();
    const txtTlf1 = useRef();
    const txtTlf2 = useRef();
    const chkIn = useRef()
    const chkIn1 = useRef()
    const chkIn2 = useRef()
    const txtCiudad = useRef();
    const txtMunicipio = useRef();
    const txtResolucion = useRef();
    const txtLicencia = useRef();
    const cmbSex = useRef();

    /*  variables de estados */
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mostrar, setMostrar] = useState(false)
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [nacnalidad, setNacnalidad] = useState("");
    const [catalogo, setCatalogo] = useState(false);
    const [habilitadoNU, setHabilitadoNU] = useState(false);
    const [operacionPer, setOperacionPer] = useState(0);
    const [observacion, setObservacion] = useState('hidden');
    const [municipios, setMunicipios] = useState()
    const [ciudades, setCiudades] = useState()
    const [body, setBody] = useState(null);
    const [values, setValues] = useState({
        apellidos: "",
        cedula: "",
        ciudad: "",
        correoe: "",
        credito: "",
        declara: 0,
        direccion: "",
        direccionage: "",
        direccionresp: "",
        email: "",
        exonintereses: false,
        exonintereses1x500: false,
        exoninteresesmina: false,
        exoninteresesproduccion: false,
        exonmultas: false,
        exonmultas1x500: false,
        exonmultasmina: false,
        exonmultasproduccion: false,
        exonrecargos: false,
        exonrecargos1x500: false,
        exonrecargosmina: false,
        exonrecargosproduccion: false,
        fechainscripcion: "",
        fechainscripcion1x1000: null,
        fechainscripcionmina: null,
        fechainscripcionproduccion: null,
        fnacimiento: "",
        idagente: "",
        idtipoagente: "",
        impuesto1x1000: false,
        mina: false,
        municipio: "",
        nacionalidad: "",
        nombre: "",
        nombres: "",
        nrolicencia: "",
        nrolicencia1x1000: null,
        nrolicenciamina: null,
        nrolicenciaproduccion: null,
        nroresolucion: "",
        nroresolucion1x1000: null,
        nroresolucionmina: null,
        nroresolucionproduccion: null,
        observacionstatus: "",
        observacionstatus1x1000: null,
        observacionstatusmina: null,
        observacionstatusproduccion: null,
        produccion: false,
        reprelegal: "",
        rif: '',
        sexo: '',
        status: '',
        status1x1000: null,
        statusmina: null,
        statusproduccion: null,
        telefono: "",
        tlf1: '',
        tlf2: ''
    });

    const styleInput = {
        backgroundColor: '#ffff',
        color: '#444242'
    }

    const styleInputDirec = {
        backgroundColor: '#ffff',
        color: '#444242',
        height: 50,

    }

    const onChange = (event) => {
        if (event.target.name === 'rif' || event.target.name === 'nombre' || event.target.name === 'direccionage' || event.target.name === 'email' || event.target.name === 'nombrerespo' || event.target.name === 'aperespo' || event.target.name === 'propiEmail' || event.target.name === 'licencia' || event.target.name === 'resolucion') {
            event.target.value = event.target.value.toUpperCase();
            setValues({ ...values, [event.target.name]: event.target.value.toUpperCase() });
        } else if (event.target.name === 'exonintereses' || event.target.name === 'exonmultas' || event.target.name === 'exonrecargos') {
            if (event.target.checked) {
                setValues({ ...values, [event.target.name]: true });

            } else {

                setValues({ ...values, [event.target.name]: false });
            }
        } else if (event.target.name === 'status') {
            if (event.target.value === '52') {
                if (observacion === 'hidden') {
                    setObservacion('visible');
                } else {
                    setObservacion('hidden');
                }
            } else {
                setObservacion('hidden');
                txtObserStatus.current.value = '';
            }
            setValues({ ...values, [event.target.name]: event.target.value });
        } else {
            setValues({ ...values, [event.target.name]: event.target.value });
        }
    };


    const handleInputMontoChange = (event) => {
        validaMonto(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            }
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        let columna;
        var sigue = true;
        if (operacion === 1 || operacion === 2) {
            if (txtId.current.value.trim() === '') {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar Alguna Cuenta.', icono: 'informacion' });
                txtId.current.focus();
                sigue = false;

            } else if (txtDebe.current.value.trim() === '') {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Ingrese el Monto del Debe.', icono: 'informacion' });
                txtDebe.current.focus();
                sigue = false;

            } else if (txtHaber.current.value.trim() === '') {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Ingrese el Monto del Haber.', icono: 'informacion' });
                txtHaber.current.focus();
                sigue = false;

            } else if (parseInt(txtDebe.current.value.trim()) > 0 && parseInt(txtHaber.current.value.trim()) > 0) {


                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Debe o el Haber de ingresarse en 0,00 a comparación del otro.', icono: 'informacion' });
                txtHaber.current.value = 0;
                txtHaber.current.focus();
                sigue = false;

            }



        }

        if (parseInt(props.tabla) === 0) {
            columna = {

                idplancuenta: parseInt(txtId.current.value),
                codigocuenta: txtCuentaContable.current.value,
                descripcion: txtDescripcion.current.value,
                debe: txtDebe.current.value.replace(/\./g, '').replace(',', '.'),
                haber: txtHaber.current.value.replace(/\./g, '').replace(',', '.'),

            }
        } else {
            columna = {

                idplancuenta: parseInt(txtId.current.value),
                codigocuenta: txtCuentaContable.current.value,
                descripcion: txtDescripcion.current.value,
                debe: txtDebe.current.value.replace(/\./g, '').replace(',', '.'),
                haber: txtHaber.current.value.replace(/\./g, '').replace(',', '.'),
                idcuentacontable: values.idcuentacontable

            }
        }



        if (sigue && !props.estadoboton) {

            props.cargarTabla(columna)

        } else if (sigue && props.estadoboton) {

            let msg = '';
            if (operacion === 1) {
                msg = 'Esta Seguro de Registrar estos Datos.';
            } else if (operacion === 2) {
                msg = 'Esta Seguro de Modificar estos Datos.';
            } else if (operacion === 3) {
                msg = 'Esta Seguro de Eliminar estos Datos.';
            }

            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });

        }

    }

    const procesarRegistro = () => {
        setActivate(true);
        let endpoint;
        let body;



        if (operacion === 1) {

            endpoint = `${op.conexion}/api/contabilidad/asientocrear`;

            body = {


                cuenta: values.codigocuenta,
                debe: txtDebe.current.value.replace(/\./g, '').replace(',', '.'),
                haber: txtHaber.current.value.replace(/\./g, '').replace(',', '.'),
                efiscal: parseInt(idefiscal),
                idcuenta: parseInt(props.tabla) === 0 ? parseInt(values.idplancuenta) : parseInt(values.idcuentacontable),
                fechaMov: fechasistema,
                idasiento: parseInt(props.asientoId),
                tipo: parseInt(props.tabla)


            }


        } else if (operacion === 2) {

            endpoint = `${op.conexion}/api/contabilidad/asientomodificar`;

            body = {

                cuenta: values.codigocuenta,
                debe: txtDebe.current.value.replace(/\./g, '').replace(',', '.'),
                haber: txtHaber.current.value.replace(/\./g, '').replace(',', '.'),
                efiscal: parseInt(idefiscal),
                idcuenta: parseInt(props.tabla) === 0 ? parseInt(values.idplancuenta) : parseInt(values.idcuentacontable),
                fechaMov: fechasistema,
                idasiento: parseInt(props.asientoId),
                idmovimiento: parseInt(props.idmovi)

            }

        } else if (operacion === 3) {

            endpoint = `${op.conexion}/api/contabilidad/asientoeliminar`;

            body = {

                cuenta: values.codigocuenta,
                efiscal: parseInt(idefiscal),
                idcuenta: parseInt(props.tabla) === 0 ? parseInt(values.idplancuenta) : parseInt(values.idcuentacontable),
                idasiento: parseInt(props.asientoId),
                idmovi: parseInt(props.idmovi)

            }


        }



        axios.post(endpoint, body, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {
            if (response.status === 200) {
                if (props.operacion === 1) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
                } else if (props.operacion === 2) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
                } else if (props.operacion === 3) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
                }

                setActivate(false);
            }
        }).catch(function (error) {
            let mensaje = '';
            if (error.response === undefined) {
                mensaje = 'Error de Conexion'
            } else {
                if (error.response.data.message === 'duplicate key value violates unique constraint "agente_rif_key"') {
                    mensaje = 'Ya existe un Registro con este rif'

                } else if (error.response.data.message === 'duplicate key value violates unique constraint "agente_email_key"') {
                    mensaje = 'Ya existe un Registro con este correo'
                }
                else {
                    mensaje = error.response.data.message
                }
            }
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
            setActivate(false);
        })
    }

    const blanquear = () => {
        setActivate(false);
        setObservacion('hidden');
        txtId.current.value = ''
        txtCedula.current.value = '';
        txtNombreRespon.current.value = '';
        txtApeRespon.current.value = '';
        txtDireccionRespon.current.value = '';
        txtEmail1.current.value = '';
        txtEmail2.current.value = '';
        txtFechNac.current.value = '';
        txtTlf1.current.value = '';
        txtTlf2.current.value = '';
        cmbNacionalidad.current.value = '';
        cmbSex.current.value = '';
        chkIn.current.checked = false;
        chkIn2.current.checked = false;
        chkIn1.current.checked = false
        setValues({

        });
        setOperacion(0);
    }

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        procesarRegistro();
    };

    const cancelar = (e) => {
        e.preventDefault();
        let columna;



        if (props.estadoboton) {

            columna = {

                idplancuenta: parseInt(txtId.current.value),
                codigocuenta: txtCuentaContable.current.value,
                descripcion: txtDescripcion.current.value,
                debe: txtDebe.current.value,
                haber: txtHaber.current.value,
                idcuentacontable: values.idcuentacontable ? values.idcuentacontable : ''

            }
            props.cargarTabla(columna)
        } else {
            props.onHideCancelar();

        }





    }

    const handleAceptaCatalogoPer = (ced, corr, tlf1, tlf2, ape, direc, fcn, nac, nom, sex) => {
        setCatalogo(false)
        setHabilitadoNU(false);
        setOperacionPer(0);
        setValues({
            ...values,
            cedula: ced,
            correoe: corr !== null ? corr.trim() : '',
            tlf1: tlf1 !== null ? tlf1.trim() : '',
            tlf2: tlf2 !== null ? tlf2.trim() : '',
            apellidos: ape !== null ? ape.trim() : '',
            direccionresp: direc !== null ? direc.trim() : '',
            fnacimiento: fcn !== null ? moment(fcn).format('YYYY-MM-DD') : '',
            nacionalidad: nac !== null ? nac.toString().trim() : '',
            nombres: nom !== null ? nom.trim() : '',
            sexo: sex !== null ? sex.toString().trim() : ''
        });
    }

    /* valdar buscador por numero cedula */
    const validarPersona = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                datosRes(event.target.value);
            }
        }
    };

    const datosRes = (cedula) => {
        let campos = '*';
        let nomtab = 'persona';
        let nomid = 'cedula';
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {
            if (response.status === 200) {
                setHabilitadoNU(true);
                setValues({
                    ...values,
                    correoe: '',
                    tlf1: '',
                    tlf2: '',
                    apellidos: '',
                    direccionresp: '',
                    fnacimiento: '',
                    nacionalidad: '',
                    nombres: '',
                    sexo: ''
                });

                if (response.data !== '') {
                    setHabilitadoNU(false);
                    setOperacionPer(0);
                    setValues({
                        ...values,
                        cedula: response.data.cedula,
                        correoe: response.data.correoe,
                        tlf1: response.data.tlf1,
                        tlf2: response.data.tlf2,
                        apellidos: response.data.apellidos,
                        direccionresp: response.data.direccion,
                        fnacimiento: moment(response.data.fnacimiento).format('YYYY-MM-DD'),
                        nacionalidad: response.data.nacionalidad.toString(),
                        nombres: response.data.nombres,
                        sexo: response.data.sexo.toString()
                    });
                } else {
                    setOperacionPer(1);
                    setHabilitadoNU(true);
                    txtNombreRespon.current.focus();
                }
            }
            setActivate(false);
        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    };


    const onHideAceptaCatalogo = (values) => {
        setValues(values)
        txtId.current.value = values.idplancuenta;
        txtCuentaContable.current.value = values.codigocuenta;
        txtDescripcion.current.value = values.descripcion;
        setMostrar(false);
    }

    const cerrarModal = () => {
        props.renderizar(props.asientoId);
        props.onHideCancelar();
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();

    }

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion)
                setHabilitadoNU(false)
                setOperacionPer(0);

                if (props.operacion !== 1) {

                    setValues(props.cuentaContable);


                } else {
                    txtDebe.current.value = '';
                    txtHaber.current.value = '';
                    setValues();

                }
            }}

        >
            <Modal.Header className='azulGradiant2 header-modal'>
                <Modal.Title style={{ color: "#fff" }}>{props.operacion === 1 ? 'Agregar Cuenta Contable.' : props.operacion === 2 ? 'Editar Cuenta Contable.' : props.operacion === 3 ? 'Eliminar Cuenta Contable.' : 'Consultar Cuenta Contable.'}</Modal.Title>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#FFF" }}>


                <div>
                    <div className='w-100 row mx-auto' style={{ fontSizeAdjust: '0.6' }}>
                        <div className="input-group input-group-sm mx-auto mb-2 col-md-4">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Código:</label>
                            <input type="text" className="form-control" ref={txtId} value={values ? values.idplancuenta !== null ? values.idplancuenta : '' : ''} aria-label="Sizing example input" disabled aria-describedby="inputGroup-sizing-sm" />
                            <button type="button" onClick={() => { setMostrar(true) }} className="btn btn-success"><i className="fas fa-search"></i></button>
                        </div>
                        <div className="input-group input-group-sm mx-auto mb-2 col-md-8">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Cuenta Contable:</label>
                            <input type="text" className="form-control" ref={txtCuentaContable} value={values ? values.codigocuenta !== null ? values.codigocuenta : '' : ''} disabled aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                        </div>
                        <div className="input-group input-group-sm mx-auto mb-2 col-md-12">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Descripción:</label>
                            <input type="text" className="form-control" ref={txtDescripcion} disabled value={values ? values.descripcion !== null ? values.descripcion : '' : ''} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                        </div>
                        <div className="input-group input-group-sm mx-auto mb-2 col-md-6">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Monto Debe:</label>
                            <input type="text" className="form-control text-right" disabled={operacion === 4 ? true : operacion === 3 ? true : false} aria-label="Sizing example input" defaultValue={values ? values.debe !== null ? values.debe : '' : ''} ref={txtDebe} aria-describedby="inputGroup-sizing-sm" onKeyUp={handleInputMontoChange} placeholder="0,00" onBlur={handleInputMontoChange} />

                        </div>
                        <div className="input-group input-group-sm mx-auto mb-2 col-md-6">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Monto Haber:</label>
                            <input type="text" className="form-control text-right" disabled={operacion === 4 ? true : operacion === 3 ? true : false} aria-label="Sizing example input" ref={txtHaber} defaultValue={values ? values.haber !== null ? values.haber : '' : ''} aria-describedby="inputGroup-sizing-sm" onKeyUp={handleInputMontoChange} placeholder="0,00" onBlur={handleInputMontoChange} />

                        </div>


                    </div>
                    <CatalogoCuentasAsientos
                        show={mostrar}
                        onHideCancelar={() => { setMostrar(false) }}
                        tabla={props.tabla}
                        onHideAceptaCatalogo={onHideAceptaCatalogo}
                    />

                    <Mensaje mensaje={mensaje}
                        onHide={() => {
                            mensaje.titulo === 'Exito.' ?
                                cerrarModal() :
                                setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                        }
                        } />
                    <MensajeSiNo mensaje={mensajesino}
                        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
                    <Dimmer active={activate} inverted>
                        <Loader inverted>cargando...</Loader>
                    </Dimmer>
                </div>
            </Modal.Body >
            <Modal.Footer>
                <button ref={btnAcepta} disabled={operacion === 4 ? true : false} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-success col-md-3"><i className="fas fa-check-circle">  Aceptar</i></button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill col-md-3"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal >
    );
}




// WEBPACK FOOTER //
// ./src/components/contabilidad/modalIncluirCuentas.js